// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SaintLucia from '../_raw/flag/icon_flag_saint_lucia.png';

export default () => <img src={SaintLucia} alt="SaintLucia" />;
